export default __webpack_public_path__ + "static/media/ai-star-animated.9edf522a.gif";